/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Landing_Web_Theme_NoteInputs */

const tr_landing_web_theme_note = /** @type {(inputs: Landing_Web_Theme_NoteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`İlk tema ATLAS: moda ve perakende için hazır. Renkler, yazı tipleri ve bölüm sıralaması panelden değişir.`)
};

const en_landing_web_theme_note = /** @type {(inputs: Landing_Web_Theme_NoteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`First theme ATLAS: ready for fashion and retail. Colours, fonts and section order are changed from the panel.`)
};

const de_landing_web_theme_note = /** @type {(inputs: Landing_Web_Theme_NoteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Erstes Design ATLAS: fertig für Mode und Einzelhandel. Farben, Schriften und Reihenfolge der Bereiche ändern Sie im Panel.`)
};

const ru_landing_web_theme_note = /** @type {(inputs: Landing_Web_Theme_NoteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Первая тема ATLAS: готова для моды и розницы. Цвета, шрифты и порядок блоков меняются в панели.`)
};

/**
* | output |
* | --- |
* | "First theme ATLAS: ready for fashion and retail. Colours, fonts and section order are changed from the panel." |
*
* @param {Landing_Web_Theme_NoteInputs} inputs
* @param {{ locale?: "tr" | "en" | "de" | "ru" }} options
* @returns {LocalizedString}
*/
export const landing_web_theme_note = /** @type {((inputs?: Landing_Web_Theme_NoteInputs, options?: { locale?: "tr" | "en" | "de" | "ru" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Landing_Web_Theme_NoteInputs, { locale?: "tr" | "en" | "de" | "ru" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_landing_web_theme_note(inputs)
	if (locale === "de") return de_landing_web_theme_note(inputs)
	if (locale === "ru") return ru_landing_web_theme_note(inputs)
	return tr_landing_web_theme_note(inputs)
});